var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRefreshTransparent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3945 5.91992H14.5391C14.1465 2.97266 11.5508 0.564453 8.36914 0.564453C6.76953 0.564453 5.31055 1.21484 4.26172 2.21094C3.86328 2.54492 3.85156 3.02539 4.0918 3.33594C4.34961 3.66406 4.8125 3.76367 5.28711 3.39453C6.08398 2.63867 7.17383 2.1582 8.36914 2.1582C10.6953 2.1582 12.5469 3.83398 12.9219 5.91992H11.9961C11.4922 5.91992 11.3398 6.34766 11.6562 6.78125L13.2324 8.95508C13.4902 9.30664 13.9004 9.30078 14.1582 8.95508L15.7344 6.78711C16.0508 6.34766 15.9102 5.91992 15.3945 5.91992ZM1.33203 7.625H2.19922C2.59766 10.5723 5.1875 12.9805 8.36914 12.9805C9.97461 12.9805 11.4336 12.3301 12.4824 11.3398C12.8809 11 12.8926 10.5137 12.6523 10.209C12.3945 9.88086 11.9316 9.78125 11.457 10.1504C10.666 10.9121 9.57031 11.3867 8.36914 11.3867C6.04297 11.3867 4.19727 9.7168 3.81641 7.625H4.73047C5.23438 7.625 5.38672 7.20312 5.06445 6.76367L3.49414 4.58984C3.23633 4.23828 2.82617 4.24414 2.56836 4.58984L0.992188 6.76367C0.669922 7.19727 0.816406 7.625 1.33203 7.625Z",
    fill: "#CC7BF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRefreshTransparent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-refresh-transparent.7893ad63a2edc306f56bb11367f00082.svg";